module.exports = __webpack_public_path__ + "static/media/Aviso Privacidad PTMT.0aa2d20b.pdf";